import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import './index.css';

const App = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // API URL for fetching registration data
  const API_URL = 'https://calcool-api.ro/api/registration/get_registrations/13/PARTICIPANT';

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const token = (process.env && process.env.REACT_APP_API_TOKEN) || '';
        const headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        };
        if (token) {
          headers['Authorization'] = 'Bearer ' + token;
        }
        const config = { headers };
        const response = await axios.get(API_URL, config);
        console.log('Fetched data:', response.data);
        setData(response.data);
      } catch (err) {
        setError(`Failed to fetch data: ${err.message}`);
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filter data based on search term
  const filteredData = useMemo(() => {
    if (!searchTerm) return data;
    
    return data.filter(item =>
      Object.values(item).some(value =>
        value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [data, searchTerm]);

  // Get table headers from the first data item
  const getHeaders = () => {
    if (data.length === 0) return [];
    return Object.keys(data[0]);
  };

  // Render cell value (handle objects and arrays)
  const renderCellValue = (value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'object') return JSON.stringify(value);
    return value.toString();
  };

  if (loading) {
    return (
      <div className="app">
        <h1>React Data Table</h1>
        <div className="loading">Loading data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app">
        <h1>React Data Table</h1>
        <div className="error">{error}</div>
        <button onClick={() => window.location.reload()}>
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="app">
      <h1>React Data Table</h1>
      <p>Fetching data from: <code>{API_URL}</code></p>
      
      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Search data..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="table-container">
        {filteredData.length === 0 ? (
          <div className="no-data">
            {searchTerm ? 'No results found for your search.' : 'No data available.'}
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                {getHeaders().map(header => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={item.id || index}>
                  {getHeaders().map(header => (
                    <td key={header}>
                      {renderCellValue(item[header])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div style={{ marginTop: '20px', color: '#666', fontSize: '14px' }}>
        Showing {filteredData.length} of {data.length} records
        {searchTerm && ` (filtered by "${searchTerm}")`}
      </div>
    </div>
  );
};

export default App;